import {Refmodel, Release, Team, Status} from '@q9elements/ui-kit/common';

export enum EntityType {
  Diagram = 'DiagramRecentlySeen',
  Map = 'MapRecentlySeen',
  Story = 'StoryRecentlySeen',
  Requirement = 'RequirementRecentlySeen',
  URL = 'URLRecentlySeen',
  Node = 'NodeRecentlySeen',
  Analytic = 'OrgAnalyticsRecentlySeen'
}

export enum EntityState {
  Draft = 'draft',
  Ready = 'ready',
  Master = 'master',
  Archive = 'archive'
}

export enum DashboardCard {
  RMN = 'rmn',
  Diagram = 'diagram',
  Map = 'map',
  Story = 'story',
  Requirement = 'requirement',
  URL = 'url_entry',
  RefModel = 'refModel'
}

export enum CHART_TYPES {
  ORG_SUMMARY = 'org-summary',
  ORG_TRENDS = 'org-summary-trends',
  DESCRIPTIONS_FILLED = 'descriptions-filled',
  DESCRIPTIONS_FILLED_LINE_CHART = 'descriptions-filled-line-chart',
  DOCUMENTATION_ALL = 'documentation-all',
  DOCUMENTATION_OBJECTS = 'documentation-objects',
  DOCUMENTATION_CUSTOM_FIELDS = 'documentation-custom-fields',
  DOCUMENTATION_WORKFLOW_FIELD_UPDATES = 'documentation-workflow-field-updates',
  DOCUMENTATION_PROCESS_BUILDER_WORKFLOWS = 'documentation-process-builder-workflows',
  DOCUMENTATION_RECORD_TYPES = 'documentation-record-types',
  DOCUMENTATION_VALIDATION_RULES = 'documentation-validation-rules',
  DOCUMENTATION_WORKFLOW_RULES = 'documentation-workflow-rules',
  PERCENTAGE_FILLED_CHART = 'percentage-filled-chart',
  RECORDS_CHART = 'records-chart',
  CUSTOM_FIELDS_IN_OBJECTS = 'custom-fields-in-objects',
  PROCESS_BUILDER_FLOWS = 'process-builder-flows',
  LAST_USED_REPORT = 'last-used-report',
  LAST_USED_EMAIL_TEMPLATE = 'last-used-email-template',
  PROFILES_CHART = 'profiles-chart',
  PS_CHART = 'ps-chart',
  LAST_LOGGED_IN = 'last-logged-in',
  LAST_LOGGED_IN_BY_PROFILES = 'last-logged-in-by-profiles',
  GDRP_FIELD_STATUS = 'gdrp-field-status',
  GDRP_FIELD_STATUS_OVER_TIME = 'gdrp-field-status-over-time',
  GDRP_LEGAL_BASIS = 'gdrp-legal-basis'
}

export const CHART_TRANSLATES = {
  [CHART_TYPES.ORG_SUMMARY]: 'REF_ANALYTICS.ORG_SUMMARY',
  [CHART_TYPES.ORG_TRENDS]: 'REF_ANALYTICS.ORG_TRENDS',
  [CHART_TYPES.DESCRIPTIONS_FILLED]: 'REF_ANALYTICS.DESCRIPTIONS_FILLED',
  [CHART_TYPES.DESCRIPTIONS_FILLED_LINE_CHART]: 'REF_ANALYTICS.DESCRIPTIONS_FILLED_LINE_CHART',
  [CHART_TYPES.DOCUMENTATION_ALL]: 'REF_ANALYTICS.DOCUMENTATION_ALL',
  [CHART_TYPES.DOCUMENTATION_OBJECTS]: 'REF_ANALYTICS.DOCUMENTATION_OBJECTS',
  [CHART_TYPES.DOCUMENTATION_CUSTOM_FIELDS]: 'REF_ANALYTICS.DOCUMENTATION_CUSTOM_FIELDS',
  [CHART_TYPES.DOCUMENTATION_WORKFLOW_FIELD_UPDATES]:
    'REF_ANALYTICS.DOCUMENTATION_WORKFLOW_FIELD_UPDATES',
  [CHART_TYPES.DOCUMENTATION_PROCESS_BUILDER_WORKFLOWS]:
    'REF_ANALYTICS.DOCUMENTATION_PROCESS_BUILDER_WORKFLOWS',
  [CHART_TYPES.DOCUMENTATION_RECORD_TYPES]: 'REF_ANALYTICS.DOCUMENTATION_RECORD_TYPES',
  [CHART_TYPES.DOCUMENTATION_VALIDATION_RULES]: 'REF_ANALYTICS.DOCUMENTATION_VALIDATION_RULES',
  [CHART_TYPES.DOCUMENTATION_WORKFLOW_RULES]: 'REF_ANALYTICS.DOCUMENTATION_WORKFLOW_RULES',
  [CHART_TYPES.PERCENTAGE_FILLED_CHART]: 'REF_ANALYTICS.PERCENTAGE_FILLED_CHART',
  [CHART_TYPES.RECORDS_CHART]: 'REF_ANALYTICS.RECORDS_CHART',
  [CHART_TYPES.CUSTOM_FIELDS_IN_OBJECTS]: 'REF_ANALYTICS.CUSTOM_FIELDS_IN_OBJECTS',
  [CHART_TYPES.PROCESS_BUILDER_FLOWS]: 'REF_ANALYTICS.PROCESS_BUILDER_FLOWS',
  [CHART_TYPES.LAST_USED_REPORT]: 'REF_ANALYTICS.LAST_USED_REPORT',
  [CHART_TYPES.LAST_USED_EMAIL_TEMPLATE]: 'REF_ANALYTICS.LAST_USED_EMAIL_TEMPLATE',
  [CHART_TYPES.PROFILES_CHART]: 'REF_ANALYTICS.PROFILES_CHART',
  [CHART_TYPES.PS_CHART]: 'REF_ANALYTICS.PS_CHART',
  [CHART_TYPES.LAST_LOGGED_IN]: 'REF_ANALYTICS.LAST_LOGGED_IN',
  [CHART_TYPES.LAST_LOGGED_IN_BY_PROFILES]: 'REF_ANALYTICS.LAST_LOGGED_IN_BY_PROFILES',
  [CHART_TYPES.GDRP_FIELD_STATUS]: 'REF_ANALYTICS.GDRP_FIELD_STATUS',
  [CHART_TYPES.GDRP_FIELD_STATUS_OVER_TIME]: 'REF_ANALYTICS.GDRP_FIELD_STATUS_OVER_TIME',
  [CHART_TYPES.GDRP_LEGAL_BASIS]: 'REF_ANALYTICS.GDRP_LEGAL_BASIS'
};

export default interface RecentlyViewed {
  _id: string;
  type: EntityType;
  lastSeenDate: string;
  user: {
    firstName: string;
    lastName: string;
  };
  space: {
    _id: string;
    name: string;
  };
  chart?: CHART_TYPES;
}

export interface PlainDashboardCard {
  title?: string;
  description?: string;
  values?: Array<string | number | boolean>;
  status?: string;
  statusColor?: string;
  additional?: string;
  changesType?: string;
}

export interface EntityVisual {
  getString?: (encodeHtml?: string, additional?: string) => string;
  link?: string;
  data?: string;
  callback?: () => null;
}

export interface InnerEntityData {
  _id: string;
  description?: string;
  details?: string;
  chart?: string;
  name: string;
  sf?: {
    id: string | null;
    longId: string | null;
    objectKeyPrefix: string | null;
    type: string;
    fullPath: string;
    apiName: string | null;
    fullApiName: string | null;
    fieldLabel: string | null;
    helpText: string | null;
    isFormulaField: boolean | null;
    displayName: string;
    isPicklistField: boolean;
    _id: string;
  };
  refModel?: Refmodel;
  sfNode?: string;
  map?: {
    name: string;
    type: string;
    _id: string;
    previewUrl: string;
  };
  diagramId?: string;
  refId: string;
  levelNumber?: string;
  state?: string;
  title?: string;
  value?: string;
  storyId?: number;
  reqId?: number;
  customId: string;
  summary?: string;
  status?: Status;
  requirement?: {summary: string};
  release?: Release;
  fullPath?: {name: string}[];
  previewUrl?: string;
  team?: Team;
}

export enum FilterValue {
  ALL = 'all',
  DIAGRAM = 'diagram',
  MAP = 'map',
  URL = 'url',
  STORY = 'story',
  REQUIREMENT = 'requirement',
  NODE = 'refModelNode',
  ORG_NODE = 'orgNode',
  ANALYTIC = 'orgAnalytic'
}

export enum DASHBOARD_TABS {
  COMPASS = 'compass',
  RECENT = 'recent',
  FOLLOWED = 'followed'
}

export const EntityTypeDictionary: Record<EntityType, DashboardCard> = {
  [EntityType.Diagram]: DashboardCard.Diagram,
  [EntityType.Map]: DashboardCard.Map,
  [EntityType.Story]: DashboardCard.Story,
  [EntityType.Requirement]: DashboardCard.Requirement,
  [EntityType.URL]: DashboardCard.URL,
  [EntityType.Analytic]: DashboardCard.RefModel,
  [EntityType.Node]: DashboardCard.RMN
};

export const EntityKeyDictionary: Record<EntityType, string> = {
  [EntityType.Diagram]: 'diagram',
  [EntityType.Map]: 'map',
  [EntityType.Story]: 'story',
  [EntityType.Requirement]: 'requirement',
  [EntityType.URL]: 'url',
  [EntityType.Node]: 'refModelNode',
  [EntityType.Analytic]: 'refModel'
};

export const DisplayTypeDictionary: {[key in EntityType]?: string} = {
  [EntityType.Diagram]: 'DASHBOARD.PROCESS_DIAGRAM_LABEL',
  [EntityType.Story]: 'DASHBOARD.USER_STORY_LABEL',
  [EntityType.Requirement]: 'DASHBOARD.REQUIREMENT_LABEL',
  [EntityType.URL]: 'DASHBOARD.URL_LIBRARY_LABEL',
  [EntityType.Node]: 'DASHBOARD.SF_ORG_MODEL_LABEL',
  [EntityType.Analytic]: 'DASHBOARD.ANALYTIC_CHART_LABEL'
};
